import React from "react";
import "./styles.css";
import {
  Form,
  Select,
  Input,
  InputNumber,
  Radio,
  Button,
  DatePicker,
} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const BilleteraForm = () => {
  return (
    <div className="billeteraform">
      <Form>
        <FormItem label="Movimientos De Plata"></FormItem>
        <span className="fit">Total:</span>
        <FormItem>
          <InputNumber
            min={1}
            max={20000000}
            placeholder="$"
            style={{ width: 150 }}
          />

          <span className="ant-form-text"> Pesos</span>
        </FormItem>

        <FormItem style={{ width: 400 }}>
          <span>De:</span>
          <Select placeholder="Billetera a">
            <Option value="fab">Fabrica</Option>
            <Option value="banco">Banco</Option>
            <Option value="g">Guille</Option>
            <Option value="b">Beta</Option>
            <Option value="a">Ale</Option>
            <Option value="m">Martin</Option>
            <Option value="h">Hannah</Option>
          </Select>
        </FormItem>
        <FormItem style={{ width: 400 }}>
          <span>Hasta:</span>
          <Select placeholder="Billetera b">
            <Option value="fabb">Fabrica</Option>
            <Option value="bancob">Banco</Option>
            <Option value="gb">Guille</Option>
            <Option value="bb">Beta</Option>
            <Option value="ab">Ale</Option>
            <Option value="mb">Martin</Option>
            <Option value="hb">Hannah</Option>
          </Select>
        </FormItem>

        <span className="fit">Fecha:</span>

        <FormItem>
          <DatePicker disableFuture />
        </FormItem>

        <FormItem wrapperCol={{ span: 12, offset: 6 }}>
          <Button type="primary" htmlType="submit">
            Agregar
          </Button>
        </FormItem>
      </Form>
    </div>
  );
};
export default BilleteraForm;
